import * as React from 'react';

// tslint:disable:max-line-length
export const NoIcon = () => (
  <svg width="96" height="96" viewBox="0 0 96 96">
    <defs>
      <circle id="spot_thumbs-down_md-a" cx="48" cy="48" r="48" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="spot_thumbs-down_md-b" fill="#fff">
        <use xlinkHref="#spot_thumbs-down_md-a" />
      </mask>
      <use fill="#F8F8F8" xlinkHref="#spot_thumbs-down_md-a" />
      <g mask="url(#spot_thumbs-down_md-b)">
        <g transform="rotate(180 48 42.5)">
          <g fill-rule="nonzero" transform="translate(0 1)">
            <path
              fill="#FFBE9D"
              d="M55.6,0.8 C56,0.5 56.7,0.4 57.3,0.5 C60.1,0.9 60.7,2.5 60.7,8 C60.7,13.5 57.9,18.6 57.3,19.8 C56.9,20.6 56.5,21.9 56,23.8 L56.0038414,24.2876268 C56.0369796,26.0146939 56.34,27.6342857 58.9,28 L62.4076708,28.5128193 C65.9452582,29.0414617 70.4143508,29.746658 70.7794871,29.9819636 L70.8,30 C70.9,30.1 70.9,30.1 70.9,30.2 C73.4,30.7 75.1,31.7 75.1,33.5 C75.4,34.4 75.4,35.7 75.1,37.4 C74.6,39.8 75.8,39.9 75.6,42.8 C75.4,45.7 74,45.9 73.6,48.6 C73.2,51.3 73.9,51.5 73.2,53.9 C72.5,56.3 72.1,55.5 71,58.1 C70.5,59.2 70.3,59.9 70.2,60.5 C70.1,61.3 69.9,62.3 69.2,63.3 C69.125,63.45 68.99375,63.6 68.890625,63.75 L68.8,63.9 L68.7265936,63.8948872 L68.5382037,64.1316795 C67.62347,65.2520577 66.6026681,66.0174901 63.5,66.2 L61.1789052,66.3173918 C59.6388656,66.3853497 58.4887496,66.3974018 55.0610793,66.3995392 L50.6346053,66.403724 C44.8337767,66.4247247 43.3387597,66.4914729 38.7,65.4 C38.0259259,65.2074074 35.682716,63.8093278 33.456277,63.8846212 L33.2,63.9 C24.8,64.4 17.3,65 10.4,65.7 C9.0875,63.95 7.8515625,62.2 6.75917969,60.3830078 L6.359,59.7025 L6.3,59.7 C2.91290323,53.7967742 0.743288241,47.0506764 0.153680642,39.9148635 L0.1,39.2 L2.60886377,39.3391796 C18.5777513,40.1971446 27.9414634,40.1414634 30.7,39 C34.6,37.4 38.7,33.6 39.7,27.1 C40.6166667,26.35 41.4638889,25.6 42.2416667,24.85 L42.7,24.4 L44.2,22.9 C47.0915663,19.9361446 51.4463347,10.1788503 53.7511091,4.77212721 L55.3,1.1 L55.6,0.8 Z"
            />
            <path
              fill="#E8A887"
              d="M33.4,34 C32.4,34.7 30.9,35.3 29.7,35.7 C23.1,36.5 12.6,36.2 0,35.2 L0,36.1 C0,37.1 0,38.1 0.1,39.2 C17.6,40.3 27.8,40.2 30.7,39 C34.6,37.4 38.7,33.6 39.7,27.1 C38.9,27.8 38.2,28.4 37.5,29 C35.1,31.2 34.4,32.3 33.4,34 Z"
            />
          </g>
          <path
            fill="#EC0000"
            d="M56.2,8.6 C56.2,8.6 56.6,7.5 57.2,5.5 C57.6,4.1 57.9,2.5 57.3,1.4 C56.7,0.4 56.2,0 55.5,0 L52.5,8 C52.7,8.2 52.9,8.3 53.8,8.5 C54.5,8.7 55.6,8.8 56.2,8.6 Z"
          />
          <path
            fill="#00B9D7"
            fill-rule="nonzero"
            d="M26.6,28.2 C27.8,28.3 28.8,29.3 28.7,30.6 L28.7,30.6 L26,67.6 C25.9,68.8 24.8,69.8 23.6,69.7 C22.4,69.6 21.4,68.6 21.5,67.3 L21.5,67.3 L24.2,30.3 C24.3,29 25.3,28.1 26.6,28.2 Z"
          />
          <path
            fill="#ABABAB"
            fill-rule="nonzero"
            d="M17.9,28.1 C19.1,28.1 20,29 20.1,30.1 L21.5,67.6 C21.5,68.7 20.6,69.7 19.5,69.8 L19.5,69.8 C18.3,69.8 17.4,68.9 17.3,67.8 L15.9,30.3 C15.8,29.1 16.7,28.2 17.9,28.1 L17.9,28.1 Z"
          />
        </g>
      </g>
    </g>
  </svg>
);
